export const VISIBILITY_GROUP = {
    NONE: 0,
    EMPLOYEES: 1,
    CLIENTS: 2,
    EMPLOYEES_AND_CLIENTS: 3,
};